import React from 'react';
import styled from 'styled-components';

const Image = styled.img`
  grid-area: image;
  max-width: 100%;
`;

export default ({ src }) => <Image src={src} />;
